import React from 'react';
import SearchIcon from '@mui/icons-material//Search';
import {
  Checkbox,
  InputAdornment,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  styled,
  TextField,
} from '@mui/material';
import { FundSearchMenuProps } from './FundSearchMenu.props';

const StyledInputAdornment = styled(InputAdornment)({
  marginRight: '8px',
  color: '#546e7a',
  padding: '12px',
});

const FundSearchMenu = ({
  handleFundFilterClose,
  fundSearchQuery,
  onSearchQueryChange,
  handleFundToggle,
  fundFilterAnchorEl,
  selectedFunds,
  filteredFunds,
}: FundSearchMenuProps) => (
  <Menu
    anchorEl={fundFilterAnchorEl}
    open={Boolean(fundFilterAnchorEl)}
    disableAutoFocusItem
    disableEnforceFocus
    onClose={handleFundFilterClose}
    slotProps={{
      paper: {
        style: {
          maxHeight: 300,
          width: 250,
        },
      },
    }}>
    <div style={{ padding: '8px 16px' }}>
      <TextField
        variant="outlined"
        size="small"
        placeholder="Search funds..."
        fullWidth
        value={fundSearchQuery}
        onChange={onSearchQueryChange}
        slotProps={{
          input: {
            startAdornment: (
              <StyledInputAdornment position="start">
                <SearchIcon fontSize="small" />
              </StyledInputAdornment>
            ),
          },
        }}
        style={{ marginBottom: 8 }}
      />
    </div>
    <List>
      {filteredFunds.map(fund => (
        <ListItem key={fund.id} onClick={() => handleFundToggle(fund.id)}>
          <ListItemIcon>
            <Checkbox edge="start" checked={selectedFunds.has(fund.id)} tabIndex={-1} disableRipple />
          </ListItemIcon>
          <ListItemText primary={fund.name} />
        </ListItem>
      ))}
    </List>

    {filteredFunds.length === 0 && (
      <MenuItem disabled>
        <ListItemText primary="No funds found" />
      </MenuItem>
    )}
  </Menu>
);

export default FundSearchMenu;
